export default function Biography() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="font-playfair text-4xl font-bold text-gray-900 mb-6">
              Biography
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed font-lora">
              <p>
                Dr. Susan Aurelia Gitelson has been President of International Consultants, Inc. and has been consulting for international business, educational, cultural and other institutions. Dr. Gitelson has been Co-Chair of the American Committee of the Maharishi University of Management, and has served on the Boards of Directors of the Maharishi School of the Age of Enlightenment, the David Lynch Foundation, and other educational and cultural organizations.
              </p>
              <p>
                Throughout her distinguished career, Dr. Gitelson has dedicated herself to advancing educational excellence and promoting philanthropic initiatives that create lasting positive change in communities worldwide. Her work spans multiple continents and has touched countless lives through strategic consulting and organizational leadership.
              </p>
              <p>
                As an author and thought leader, Dr. Gitelson brings decades of experience in international consulting and nonprofit management to her writing. Her expertise in philanthropy and giving strategies has made her a sought-after advisor for individuals and organizations seeking to maximize their charitable impact.
              </p>
              <p>
                Dr. Gitelson's commitment to education, cultural advancement, and social responsibility continues to inspire others to engage in meaningful philanthropic work, regardless of their financial capacity. Her belief that giving is not just for the very rich has shaped her approach to making philanthropy accessible to all.
              </p>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[3/4] rounded-lg overflow-hidden shadow-2xl">
                <img
                  src="https://m.media-amazon.com/images/I/617pKGBexKL._SY600_.jpg"
                  alt="Dr. Susan Aurelia Gitelson"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#8B4513]/10 rounded-lg -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
